import Vue from "vue";
import Router from "vue-router";

import { store } from "../store";

// Layouts
import Full from "../containers/Full.vue";

// Auth Pages
import LoginPage from "../views/pages/Login.vue";
import RegistrationPage from "../views/pages/Registration.vue";
import ForgottenPasswordPage from "../views/pages/ForgottenPassword.vue";
import ResetPasswordPage from "../views/pages/ResetPassword.vue";
import AccountValidationPage from "../views/pages/AccountValidation.vue";

// Admin pages
import Users from "../views/pages/Users.vue";
import User from "../views/pages/User.vue";
import PerformanceOverview from "../views/pages/PerformanceOverview.vue";
import ContentSets from "../views/pages/ContentSets.vue";
import ContentSet from "../views/pages/ContentSet.vue";
import Publishers from "../views/pages/Publishers.vue";
import PublisherManager from "../views/pages/Publisher.vue";
import PropertyManager from "../views/pages/Property.vue";
import ZoneManager from "../views/pages/Zone.vue";

// General Pages
import Dashboard from "../views/pages/Dashboard.vue";
import Profile from "../views/pages/Profile.vue";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      name: "Home",
      component: Full,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "users",
          name: "Users",
          redirect: "/users/home",

          component: {
            render(c) { return c("router-view"); }
          },
          children: [{
            path: "home",
            name: "User Management",
            component: Users,
            meta: {
              requiresAuth: true,
              role: "Admin"
            }
          },
          {
            path: ":id",
            name: "User",
            component: User,
            props: true,
            meta: {
              requiresAuth: true,
              role: "Admin"
            }
          },
          {
            path: "profile",
            name: "Profile",
            component: Profile,
            meta: {
              requiresAuth: true
            }
          }]
        },
        {
          path: "performance-overview",
          name: "Performance Overview",
          component: PerformanceOverview,
          meta: {
            requiresAuth: true,
            role: "Admin"
          }
        },
        {
          path: "content-manager",
          name: "Content",
          redirect: "/content-manager/manager",

          component: {
            render(c) { return c("router-view"); }
          },
          children: [{
            path: "manager",
            name: "Content Manager",
            component: ContentSets,
            meta: {
              requiresAuth: true,
              role: "Admin"
            }
          },
          {
            path: ":id",
            name: "Content Set",
            component: ContentSet,
            props: true,
            meta: {
              requiresAuth: true,
              role: "Admin"
            }
          }]
        },
        {
          path: "publisher-manager",
          name: "Publishers",
          redirect: "/publisher-manager/manager",

          component: {
            render(c) { return c("router-view"); }
          },
          children: [{
            path: "manager",
            name: "Publisher Management",
            component: Publishers,
            meta: {
              requiresAuth: true,
              role: "Admin"
            }
          },
          {
            path: ":publisherId",
            name: "Publisher",
            redirect: "/publisher-manager/:publisherId/publisher",
            component: {
              render(c) { return c("router-view"); }
            },
            children: [
              {
                path: "publisher",
                name: "Publisher Manager",
                component: PublisherManager,
                props: true,
                meta: {
                  requiresAuth: true,
                  role: "Admin"
                }
              },
              {
                path: "property/:propertyId",
                name: "Property",
                redirect: "/publisher-manager/:publisherId/property/:propertyId/property",
                component: {
                  render(c) { return c("router-view"); }
                },
                meta: {
                  requiresAuth: true,
                  role: "Admin"
                },

                children: [
                  {
                    path: "property",
                    name: "Property Manager",
                    component: PropertyManager,
                    props: true,
                    meta: {
                      requiresAuth: true,
                      role: "Admin"
                    }
                  },
                  {
                    path: "zone/:zoneId",
                    name: "Zone",
                    component: ZoneManager,
                    props: true,
                    meta: {
                      requiresAuth: true,
                      role: "Admin"
                    }
                  }]
              }]
          }]
        }
      ]
    },
    {
      path: "/auth/login",
      name: "LoginPage",
      component: LoginPage,
    },
    {
      path: "/auth/register",
      name: "RegistrationPage",
      component: RegistrationPage,
    },
    {
      path: "/auth/forgottenpassword",
      name: "ForgottenPasswordPage",
      component: ForgottenPasswordPage,
    },
    {
      path: "/auth/resetpassword",
      name: "ResetPasswordPage",
      component: ResetPasswordPage,
      props: (route) => ({ token: route.query.token, emailaddress: route.query.emailaddress })
    },
    {
      path: "/auth/emailvalidation",
      name: "AccountValidationPage",
      component: AccountValidationPage,
      props: (route) => ({ status: (String(route.query.success).toLowerCase() === "true") })
    }
  ],
});

router.beforeEach((to: any, from: any, next: any) => {
  if (to.meta.requiresAuth) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters["userModule/isAuthenticated"]) {
      next({
        name: "LoginPage",
        query: { redirect: to.fullPath },
      });
    } else {
      if (to.meta.role === "Admin" && !store.getters["userModule/isAdmin"]) {
        next({
          name: "Home"
        });
      } else {
        next();
      }
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
